import {FiltersProvider} from './providers/filters/FiltersProvider.tsx'
import {DashboardContainer} from './DashboardContainer.tsx'

export const DashboardScreen = () => {
  return (
    <FiltersProvider>
      <DashboardContainer />
    </FiltersProvider>
  )
}
